import { FeatureCapabilityDTO, FeatureEnabledDTO, PrivateFeatureCapabilityDTO } from "app/models/feature-flag.model";
import { StatusFeatureFlag } from "enums/feature-flag.enum";
import { Observable } from "rxjs";

export abstract class AbFeatureFlag {
 abstract carregarCapabilities(): Observable<void>;
 abstract carregarCapabilitiesPrivadas(): Observable<void>;
 abstract limparCapabilitiesPrivadas(): void;
 abstract carregarCapabilitiesConta(): Observable<void>;
 abstract limparCapabilitiesConta(): void;
 abstract verificarFlagAtiva(nome: string): StatusFeatureFlag;
 abstract obterFlag(nome: string): FeatureCapabilityDTO | PrivateFeatureCapabilityDTO | FeatureEnabledDTO | null;
 abstract obterFlagConta(nome: string): FeatureEnabledDTO | null;
 abstract obterHorarioServidor(): Date | null;
}
